/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { DamageAssessor } from '../models';
// @ts-ignore
import { OpeningHours } from '../models';
// @ts-ignore
import { RepairShop } from '../models';
// @ts-ignore
import { RepairShopVacation } from '../models';
// @ts-ignore
import { RepairshopsIdDamageassessorsDamageAssessorIdPutRequest } from '../models';
// @ts-ignore
import { SpecialOffer } from '../models';
/**
 * RepairshopsApi - axios parameter creator
 * @export
 */
export const RepairshopsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get opening hours for repairshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openinghoursGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/openinghours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Put opening hours for repairshop
         * @param {string} id 
         * @param {OpeningHours} [openingHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openinghoursIdPut: async (id: string, openingHours?: OpeningHours, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('openinghoursIdPut', 'id', id)
            const localVarPath = `/openinghours/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openingHours, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all vacations for repairshop
         * @param {number} personId 
         * @param {string} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsGet: async (personId: number, time: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('repairshopVacationsGet', 'personId', personId)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('repairshopVacationsGet', 'time', time)
            const localVarPath = `/repairshop_vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (personId !== undefined) {
                localVarQueryParameter['person_id'] = personId;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopVacationsIdDelete', 'id', id)
            const localVarPath = `/repairshop_vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopVacationsIdGet', 'id', id)
            const localVarPath = `/repairshop_vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific Vacation
         * @param {number} id 
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdPut: async (id: number, repairShopVacation?: RepairShopVacation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopVacationsIdPut', 'id', id)
            const localVarPath = `/repairshop_vacations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairShopVacation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save new Vacation
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsPost: async (repairShopVacation?: RepairShopVacation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/repairshop_vacations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairShopVacation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all RepairShops
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {number} [damageAssessorsCompanyId] Get damage_assessors_company items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsGet: async (isCarDealership?: number, trashed?: number, offset?: number, size?: number, damageAssessorsCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/repairshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (isCarDealership !== undefined) {
                localVarQueryParameter['is_car_dealership'] = isCarDealership;
            }

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (damageAssessorsCompanyId !== undefined) {
                localVarQueryParameter['damage_assessors_company_id'] = damageAssessorsCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable damage assessor for the repair shop
         * @param {number} id 
         * @param {number} damageAssessorId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDamageassessorsDamageAssessorIdPut: async (id: number, damageAssessorId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdDamageassessorsDamageAssessorIdPut', 'id', id)
            // verify required parameter 'damageAssessorId' is not null or undefined
            assertParamExists('repairshopsIdDamageassessorsDamageAssessorIdPut', 'damageAssessorId', damageAssessorId)
            const localVarPath = `/repairshops/{id}/damageassessors/{damageAssessorId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageAssessorId"}}`, encodeURIComponent(String(damageAssessorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairshopsIdDamageassessorsDamageAssessorIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get damage assessors for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDamageassessorsGet: async (id: number, trashed?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdDamageassessorsGet', 'id', id)
            const localVarPath = `/repairshops/{id}/damageassessors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to delete a repairshops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdDelete', 'id', id)
            const localVarPath = `/repairshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a specific RepairShops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdGet', 'id', id)
            const localVarPath = `/repairshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable lawyer office for the repair shop
         * @param {number} id 
         * @param {number} lawyerOfficeId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdLawyerOfficesLawyerOfficeIdPut: async (id: number, lawyerOfficeId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdLawyerOfficesLawyerOfficeIdPut', 'id', id)
            // verify required parameter 'lawyerOfficeId' is not null or undefined
            assertParamExists('repairshopsIdLawyerOfficesLawyerOfficeIdPut', 'lawyerOfficeId', lawyerOfficeId)
            const localVarPath = `/repairshops/{id}/lawyer_offices/{lawyerOfficeId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lawyerOfficeId"}}`, encodeURIComponent(String(lawyerOfficeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairshopsIdDamageassessorsDamageAssessorIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get lawyer offices for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdLawyersOfficesGet: async (id: number, trashed?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdLawyersOfficesGet', 'id', id)
            const localVarPath = `/repairshops/{id}/lawyers_offices`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific RepairShops
         * @param {number} id 
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdPut: async (id: number, repairShop?: RepairShop, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairshopsIdPut', 'id', id)
            const localVarPath = `/repairshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairShop, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new repairShop
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsPost: async (isCarDealership?: number, repairShop?: RepairShop, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/repairshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (isCarDealership !== undefined) {
                localVarQueryParameter['is_car_dealership'] = isCarDealership;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairShop, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get opening hours for repairshop
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersGet: async (page?: number, paginate?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/specialOffers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (paginate !== undefined) {
                localVarQueryParameter['paginate'] = paginate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specialOffersIdDelete', 'id', id)
            const localVarPath = `/specialOffers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specialOffersIdGet', 'id', id)
            const localVarPath = `/specialOffers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Special Offer
         * @param {number} id 
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdPut: async (id: number, specialOffer?: SpecialOffer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specialOffersIdPut', 'id', id)
            const localVarPath = `/specialOffers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specialOffer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save Special Offer
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersPost: async (specialOffer?: SpecialOffer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/specialOffers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specialOffer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairshopsApi - functional programming interface
 * @export
 */
export const RepairshopsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairshopsApiAxiosParamCreator(configuration)
    return {
        /**
         * get opening hours for repairshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openinghoursGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeningHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openinghoursGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Put opening hours for repairshop
         * @param {string} id 
         * @param {OpeningHours} [openingHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openinghoursIdPut(id: string, openingHours?: OpeningHours, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeningHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openinghoursIdPut(id, openingHours, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all vacations for repairshop
         * @param {number} personId 
         * @param {string} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopVacationsGet(personId: number, time: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairShopVacation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopVacationsGet(personId, time, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopVacationsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopVacationsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get one Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopVacationsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairShopVacation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopVacationsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific Vacation
         * @param {number} id 
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopVacationsIdPut(id: number, repairShopVacation?: RepairShopVacation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopVacationsIdPut(id, repairShopVacation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save new Vacation
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopVacationsPost(repairShopVacation?: RepairShopVacation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopVacationsPost(repairShopVacation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all RepairShops
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {number} [damageAssessorsCompanyId] Get damage_assessors_company items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsGet(isCarDealership?: number, trashed?: number, offset?: number, size?: number, damageAssessorsCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairShop>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsGet(isCarDealership, trashed, offset, size, damageAssessorsCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable or disable damage assessor for the repair shop
         * @param {number} id 
         * @param {number} damageAssessorId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdDamageassessorsDamageAssessorIdPut(id: number, damageAssessorId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdDamageassessorsDamageAssessorIdPut(id, damageAssessorId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get damage assessors for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdDamageassessorsGet(id: number, trashed?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageAssessor>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdDamageassessorsGet(id, trashed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to delete a repairshops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get a specific RepairShops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairShop>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable or disable lawyer office for the repair shop
         * @param {number} id 
         * @param {number} lawyerOfficeId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdLawyerOfficesLawyerOfficeIdPut(id: number, lawyerOfficeId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdLawyerOfficesLawyerOfficeIdPut(id, lawyerOfficeId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get lawyer offices for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdLawyersOfficesGet(id: number, trashed?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Company>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdLawyersOfficesGet(id, trashed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific RepairShops
         * @param {number} id 
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsIdPut(id: number, repairShop?: RepairShop, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairShop>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsIdPut(id, repairShop, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new repairShop
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairshopsPost(isCarDealership?: number, repairShop?: RepairShop, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairShop>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairshopsPost(isCarDealership, repairShop, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get opening hours for repairshop
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialOffersGet(page?: number, paginate?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpecialOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialOffersGet(page, paginate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialOffersIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialOffersIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialOffersIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialOffersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change Special Offer
         * @param {number} id 
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialOffersIdPut(id: number, specialOffer?: SpecialOffer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialOffersIdPut(id, specialOffer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save Special Offer
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialOffersPost(specialOffer?: SpecialOffer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialOffersPost(specialOffer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RepairshopsApi - factory interface
 * @export
 */
export const RepairshopsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairshopsApiFp(configuration)
    return {
        /**
         * get opening hours for repairshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openinghoursGet(options?: any): AxiosPromise<OpeningHours> {
            return localVarFp.openinghoursGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Put opening hours for repairshop
         * @param {string} id 
         * @param {OpeningHours} [openingHours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openinghoursIdPut(id: string, openingHours?: OpeningHours, options?: any): AxiosPromise<OpeningHours> {
            return localVarFp.openinghoursIdPut(id, openingHours, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all vacations for repairshop
         * @param {number} personId 
         * @param {string} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsGet(personId: number, time: string, options?: any): AxiosPromise<Array<RepairShopVacation>> {
            return localVarFp.repairshopVacationsGet(personId, time, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopVacationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one Vacation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdGet(id: number, options?: any): AxiosPromise<RepairShopVacation> {
            return localVarFp.repairshopVacationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific Vacation
         * @param {number} id 
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsIdPut(id: number, repairShopVacation?: RepairShopVacation, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopVacationsIdPut(id, repairShopVacation, options).then((request) => request(axios, basePath));
        },
        /**
         * Save new Vacation
         * @param {RepairShopVacation} [repairShopVacation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopVacationsPost(repairShopVacation?: RepairShopVacation, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopVacationsPost(repairShopVacation, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all RepairShops
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {number} [damageAssessorsCompanyId] Get damage_assessors_company items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsGet(isCarDealership?: number, trashed?: number, offset?: number, size?: number, damageAssessorsCompanyId?: number, options?: any): AxiosPromise<Array<RepairShop>> {
            return localVarFp.repairshopsGet(isCarDealership, trashed, offset, size, damageAssessorsCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable damage assessor for the repair shop
         * @param {number} id 
         * @param {number} damageAssessorId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDamageassessorsDamageAssessorIdPut(id: number, damageAssessorId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopsIdDamageassessorsDamageAssessorIdPut(id, damageAssessorId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get damage assessors for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDamageassessorsGet(id: number, trashed?: number, options?: any): AxiosPromise<Array<DamageAssessor>> {
            return localVarFp.repairshopsIdDamageassessorsGet(id, trashed, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete a repairshops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get a specific RepairShops
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdGet(id: number, options?: any): AxiosPromise<RepairShop> {
            return localVarFp.repairshopsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable lawyer office for the repair shop
         * @param {number} id 
         * @param {number} lawyerOfficeId 
         * @param {number} [trashed] Get trashed items.
         * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdLawyerOfficesLawyerOfficeIdPut(id: number, lawyerOfficeId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: any): AxiosPromise<void> {
            return localVarFp.repairshopsIdLawyerOfficesLawyerOfficeIdPut(id, lawyerOfficeId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get lawyer offices for repairs shop
         * @param {number} id 
         * @param {number} [trashed] Get trashed items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdLawyersOfficesGet(id: number, trashed?: number, options?: any): AxiosPromise<Array<Company>> {
            return localVarFp.repairshopsIdLawyersOfficesGet(id, trashed, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific RepairShops
         * @param {number} id 
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsIdPut(id: number, repairShop?: RepairShop, options?: any): AxiosPromise<RepairShop> {
            return localVarFp.repairshopsIdPut(id, repairShop, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new repairShop
         * @param {number} [isCarDealership] Get is_car_dealership items.
         * @param {RepairShop} [repairShop] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairshopsPost(isCarDealership?: number, repairShop?: RepairShop, options?: any): AxiosPromise<RepairShop> {
            return localVarFp.repairshopsPost(isCarDealership, repairShop, options).then((request) => request(axios, basePath));
        },
        /**
         * get opening hours for repairshop
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersGet(page?: number, paginate?: number, options?: any): AxiosPromise<Array<SpecialOffer>> {
            return localVarFp.specialOffersGet(page, paginate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.specialOffersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Show Special Offer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdGet(id: number, options?: any): AxiosPromise<SpecialOffer> {
            return localVarFp.specialOffersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Special Offer
         * @param {number} id 
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersIdPut(id: number, specialOffer?: SpecialOffer, options?: any): AxiosPromise<SpecialOffer> {
            return localVarFp.specialOffersIdPut(id, specialOffer, options).then((request) => request(axios, basePath));
        },
        /**
         * Save Special Offer
         * @param {SpecialOffer} [specialOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersPost(specialOffer?: SpecialOffer, options?: any): AxiosPromise<SpecialOffer> {
            return localVarFp.specialOffersPost(specialOffer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepairshopsApi - object-oriented interface
 * @export
 * @class RepairshopsApi
 * @extends {BaseAPI}
 */
export class RepairshopsApi extends BaseAPI {
    /**
     * get opening hours for repairshop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public openinghoursGet(options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).openinghoursGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Put opening hours for repairshop
     * @param {string} id 
     * @param {OpeningHours} [openingHours] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public openinghoursIdPut(id: string, openingHours?: OpeningHours, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).openinghoursIdPut(id, openingHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all vacations for repairshop
     * @param {number} personId 
     * @param {string} time 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopVacationsGet(personId: number, time: string, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopVacationsGet(personId, time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Vacation
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopVacationsIdDelete(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopVacationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one Vacation
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopVacationsIdGet(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopVacationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific Vacation
     * @param {number} id 
     * @param {RepairShopVacation} [repairShopVacation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopVacationsIdPut(id: number, repairShopVacation?: RepairShopVacation, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopVacationsIdPut(id, repairShopVacation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save new Vacation
     * @param {RepairShopVacation} [repairShopVacation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopVacationsPost(repairShopVacation?: RepairShopVacation, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopVacationsPost(repairShopVacation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all RepairShops
     * @param {number} [isCarDealership] Get is_car_dealership items.
     * @param {number} [trashed] Get trashed items.
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {number} [damageAssessorsCompanyId] Get damage_assessors_company items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsGet(isCarDealership?: number, trashed?: number, offset?: number, size?: number, damageAssessorsCompanyId?: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsGet(isCarDealership, trashed, offset, size, damageAssessorsCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable damage assessor for the repair shop
     * @param {number} id 
     * @param {number} damageAssessorId 
     * @param {number} [trashed] Get trashed items.
     * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdDamageassessorsDamageAssessorIdPut(id: number, damageAssessorId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdDamageassessorsDamageAssessorIdPut(id, damageAssessorId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get damage assessors for repairs shop
     * @param {number} id 
     * @param {number} [trashed] Get trashed items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdDamageassessorsGet(id: number, trashed?: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdDamageassessorsGet(id, trashed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to delete a repairshops
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdDelete(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a specific RepairShops
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdGet(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable lawyer office for the repair shop
     * @param {number} id 
     * @param {number} lawyerOfficeId 
     * @param {number} [trashed] Get trashed items.
     * @param {RepairshopsIdDamageassessorsDamageAssessorIdPutRequest} [repairshopsIdDamageassessorsDamageAssessorIdPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdLawyerOfficesLawyerOfficeIdPut(id: number, lawyerOfficeId: number, trashed?: number, repairshopsIdDamageassessorsDamageAssessorIdPutRequest?: RepairshopsIdDamageassessorsDamageAssessorIdPutRequest, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdLawyerOfficesLawyerOfficeIdPut(id, lawyerOfficeId, trashed, repairshopsIdDamageassessorsDamageAssessorIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get lawyer offices for repairs shop
     * @param {number} id 
     * @param {number} [trashed] Get trashed items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdLawyersOfficesGet(id: number, trashed?: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdLawyersOfficesGet(id, trashed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific RepairShops
     * @param {number} id 
     * @param {RepairShop} [repairShop] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsIdPut(id: number, repairShop?: RepairShop, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsIdPut(id, repairShop, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new repairShop
     * @param {number} [isCarDealership] Get is_car_dealership items.
     * @param {RepairShop} [repairShop] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public repairshopsPost(isCarDealership?: number, repairShop?: RepairShop, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).repairshopsPost(isCarDealership, repairShop, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get opening hours for repairshop
     * @param {number} [page] Pagenumber
     * @param {number} [paginate] Items shown per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public specialOffersGet(page?: number, paginate?: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).specialOffersGet(page, paginate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Special Offer
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public specialOffersIdDelete(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).specialOffersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show Special Offer
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public specialOffersIdGet(id: number, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).specialOffersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Special Offer
     * @param {number} id 
     * @param {SpecialOffer} [specialOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public specialOffersIdPut(id: number, specialOffer?: SpecialOffer, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).specialOffersIdPut(id, specialOffer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save Special Offer
     * @param {SpecialOffer} [specialOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairshopsApi
     */
    public specialOffersPost(specialOffer?: SpecialOffer, options?: AxiosRequestConfig) {
        return RepairshopsApiFp(this.configuration).specialOffersPost(specialOffer, options).then((request) => request(this.axios, this.basePath));
    }
}
